import React, { Fragment, useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import DefaultLayouts from './DefaultLayouts';
import LoginPageView from './pages/auth/LoginPageView';
import AuthContext, { AuthProvider } from './context/AuthContext';
import RequireAuth from './helpers/redirectAuth';
import { useTimeZone } from './context/TimeZoneProvider';
import TimeZoneView from './components/auth/TimeZoneView';
import { HashRouter } from 'react-router-dom';

const App: React.FC = () => {
  const { isAuthenticated } = useContext(AuthContext) || {};
  const { isNepalTime } = useTimeZone();

  if (!isNepalTime) {
      return <TimeZoneView />;
  }
  return (
      <Fragment>
          <HashRouter>
              <AuthProvider>
                  <Routes>
                      {/* Redirect authenticated users from login to dashboard */}
                      <Route 
                          path="/" 
                          element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPageView />} 
                      />
                      {/* Protect other routes */}
                      <Route element={<RequireAuth />}>
                          <Route path="*" element={<DefaultLayouts />} />
                      </Route>
                  </Routes>
              </AuthProvider>
          </HashRouter>
      </Fragment>
  );
};

export default App;
